// Функция для расчета значения столбца "0%" (аналогично I_zdor в Form4)
export const calculateDamage_0 = (item) => {
  const otherColumns = [
    'objedola25', 'objedola50', 'objedola75', 'objedola100'
  ];
  
  const sum = otherColumns.reduce((total, column) => {
    const value = item[column];
    if (value === '' || value === undefined || value === null) {
      return total + 0;
    }
    const numValue = parseFloat(value);
    return total + (isNaN(numValue) ? 0 : numValue);
  }, 0);
  
  return Math.max(0, 100 - sum);
};

// Функция для проверки валидности суммы столбцов повреждений
export const isDamageSumValid = (item) => {
  const otherColumns = [
    'objedola25', 'objedola50', 'objedola75', 'objedola100'
  ];
  
  const sum = otherColumns.reduce((total, column) => {
    const value = item[column];
    if (value === '' || value === undefined || value === null) {
      return total + 0;
    }
    const numValue = parseFloat(value);
    return total + (isNaN(numValue) ? 0 : numValue);
  }, 0);
  
  return sum <= 100;
};

// Функция для расчета "Повреждение крон"
export const calculateDamagePercentage = (item) => {
  const damage0 = parseFloat(calculateDamage_0(item)) || 0;
  const damage25 = parseFloat(item.objedola25) || 0;
  const damage50 = parseFloat(item.objedola50) || 0;
  const damage75 = parseFloat(item.objedola75) || 0;
  const damage100 = parseFloat(item.objedola100) || 0;

  const denominator = damage0 + damage25 + damage50 + damage75 + damage100;
  if (denominator <= 0) {
    return 0;
  }

  const numerator =
    damage0 * 0 +
    damage25 * 13 +
    damage50 * 38 +
    damage75 * 63 +
    damage100 * 88;

  return Math.round((numerator / denominator) * 100) / 100;
};

